import { TimelineMax, Power4 } from 'gsap/all';
import title from '@/scripts/animations/title';
import { qs } from '@/scripts/utils';

export default function pictureAnimation(el) {
  const ctx = el instanceof HTMLElement ? el : el.node;
  const titleEl = qs('.line-text__title', ctx);
  const line = qs('.line-text__line', ctx);
  const tl = new TimelineMax();

  tl.addLabel('strat')
    .to(ctx, 0.01, { autoAlpha: 1 }, 'start')
    .add(title(titleEl), 'start')
    .fromTo(line, 0.8, {
      scaleX: 0,
    }, {
      scaleX: 1,
      transformOrigin: '0% 50%',
      ease: Power4.easeOut,
      clearProps: 'all',
    }, 'start');

  return tl;
}
